/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../theme/ThemeContext';

const features = [
  { icon: 'bi-diagram-3', title: 'Visual Schema Designer', desc: 'Create Tables, set relationships between tables with simple forms. No code or migration files required.' },
  { icon: 'bi-people', title: 'User Management', desc: 'Create and Manage User accounts per application, enable Sign up' },
  { icon: 'bi-shield-lock', title: 'Role-Based Security', desc: 'Granular control. Define Read/Write/Delete/Update permissions per role, Table level permissions' },
  { icon: 'bi-magic', title: 'Auto-Generated UI', desc: 'Stop building CRUD. arcee generates validation-ready interfaces for you.' },
  { icon: 'bi-hdd-network', title: 'True Multi-Tenancy', desc: 'Data Sandboxing ensures each application gets its own isolated tables and credentials.' },
  { icon: 'bi-search', title: 'Smart Search', desc: 'Integrated full-text search and filtering across your data without extra configuration.' },
  { icon: 'bi-phone', title: 'Mobile Native', desc: 'Responsive out of the box. Your business apps work perfectly on tablets and phones.' },
  { icon: 'bi-code-square', title: 'API First', desc: 'Every model automatically exposes a secure, documented OAuth2 API for external integration.' }
];

function Features() {
  const { theme } = useTheme();
  return (
    <section id="features" className="features bg-white py-5">
      <div className="container py-5">
        <div className="text-center mb-5">
          <h6 className="fw-bold mb-2" style={{ color: theme.secondary, letterSpacing: '2px', textTransform: 'uppercase' }}>
            WHY ARCEE?
          </h6>
          <h2 className="fw-bold display-4 mb-3" style={{ color: theme.primary }}>
            Built for Serious Builders
          </h2>
        </div>

        <div className="row g-4">
          {features.map((f, i) => (
            <div className="col-md-3" key={f.title}>
              <div
                className="feature-card h-100 p-4 bg-light text-start"
                style={{
                  borderRadius: theme.cardRadius,
                  borderBottom: `2px solid transparent`, // Placeholder for hover effect
                }}
              >
                <div className="mb-3">
                  <i className={`${f.icon} display-6`} style={{ color: theme.primary }}></i>
                </div>
                <h5 className="fw-bold mb-2">{f.title}</h5>
                <p className="text-muted small mb-0">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Features;
